document.addEventListener('DOMContentLoaded', function () {
  function start() {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) {
      setTimeout(start, 100);
      return;
    }
    var $ = window.jQuery;

    var isInit = false;
    var videosLoaded = false;

    function initPopup(index) {
      if (!isInit) {
        $('.popup-main-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          arrows: false,
          infinite: false,
          adaptiveHeight: false,
          asNavFor: '.popup-thumb-slider',
          swipe: true,
          touchMove: true
        });

        $('.popup-thumb-slider').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          focusOnSelect: true,
          arrows: true,
          infinite: false,
          asNavFor: '.popup-main-slider'
        });

        $('.popup-main-slider').on('afterChange', function () {
          autoplayVideo();
        });

        isInit = true;
      }

      $('.popup-main-slider').slick('slickGoTo', index, true);

      setTimeout(function () {
        autoplayVideo();
      }, 200);
    }

    function autoplayVideo() {
      $('.popup-main-slider video').each(function () {
        this.pause();
        this.currentTime = 0;
      });

      var current = $('.popup-main-slider .slick-current video')[0];
      $('.popup-main-slider .popup-slide').removeClass('video-playing');
      if (current) {
        var playPromise = current.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            current.muted = true;
            $(current).parents('.popup-slide').addClass('muted');
            current.play().catch(function () {});
          });
        }
        $(current).parents('.popup-slide').addClass('video-playing');
      }
    }

    function attachSource(video, onDone) {
      var src = video.dataset.src;

      if (!src || video.querySelector('source')) {
        if (onDone) onDone();
        return;
      }

      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        if (onDone) onDone();
      }

      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);

      video.addEventListener('loadeddata', done);
      video.addEventListener('error', done);
      video.load();
    }

    function loadPopupVideos(priorityIndex) {
      if (videosLoaded) return;
      videosLoaded = true;

      var mainVideos = Array.prototype.slice.call(
        document.querySelectorAll('.popup-main-slider video')
      );
      var thumbVideos = Array.prototype.slice.call(
        document.querySelectorAll('.popup-thumb-slider video')
      );

      var total = mainVideos.length + thumbVideos.length;
      var loaded = 0;

      function markLoaded() {
        loaded++;
        if (loaded >= total) {
          var mainSlider = document.querySelector('.popup-main-slider');
          if (mainSlider) mainSlider.classList.add('all-videos-loaded');
        }
      }

      var priority = mainVideos[priorityIndex] || mainVideos[0];
      var restStarted = false;

      function loadRest() {
        if (restStarted) return;
        restStarted = true;

        mainVideos.forEach(function (v) {
          if (v === priority) return;
          attachSource(v, markLoaded);
        });
        thumbVideos.forEach(function (v) {
          attachSource(v, markLoaded);
        });
      }

      if (priority) {
        attachSource(priority, function () {
          markLoaded();
          loadRest();
        });
        setTimeout(loadRest, 1500);
      } else {
        loadRest();
      }
    }

    // CLICK AUF KACHEL IN DER SCROLL-REIHE
    $(document).on('click', '.new-social-proof-container .video-container-main', function () {
      var idx = $(this).attr('data-popup-index');
      if (typeof idx === 'undefined') {
        // GIF-Slot: kein Popup
        return;
      }
      idx = parseInt(idx, 10);
      if (isNaN(idx)) idx = 0;

      loadPopupVideos(idx);
      $('#videoModal').fadeIn();
      setTimeout(function () {
        initPopup(idx);
      }, 100);
    });

    // PLAY BUTTON
    $(document).on('click', '.play-btn', function () {
      var slide = $(this).closest('.popup-slide');
      var video = slide.find('video')[0];
      if (!video) return;
      video.play().catch(function () {});
      slide.addClass('video-playing');
    });

    // SOUND BUTTON
    $(document).on('click', '.sound-btn', function (e) {
      e.stopPropagation();

      var slide = $(this).closest('.popup-slide');
      var video = slide.find('video')[0];
      if (!video) return;

      if (video.muted) {
        video.muted = false;
        slide.removeClass('muted');
      } else {
        video.muted = true;
        slide.addClass('muted');
      }
    });

    // VIDEO TAP: PLAY / PAUSE
    $(document).on('click', '.popup-slide video', function () {
      var video = this;
      var slide = $(this).closest('.popup-slide');

      if (video.paused) {
        video.play().catch(function () {});
        slide.addClass('video-playing');
      } else {
        video.pause();
        slide.removeClass('video-playing');
      }
    });

    // CLOSE
    $(document).on('click', '.close-modal', function () {
      $('#videoModal').fadeOut();
      $('.popup-main-slider video').each(function () {
        this.pause();
      });
    });
  }

  start();
});